import React from 'react'
import PropTypes from 'prop-types'
import Navigation from './Navigation'
import ContentArea from './ContentArea'

const Sidebar = ({ active, share, collapsed, onMenu, setCollapsed, children }) => (
    <div className="column sidebar">
        <Navigation active={active} share={share} onMenu={onMenu} collapsed={collapsed} setCollapsed={setCollapsed} />
        <ContentArea active={active} collapsed={collapsed}>
            {children}
        </ContentArea>
    </div>
)

Sidebar.propTypes = {
    active: PropTypes.string.isRequired,
    share: PropTypes.bool,
    collapsed: PropTypes.bool.isRequired,
    onMenu: PropTypes.func.isRequired,
    setCollapsed: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
}

Sidebar.defaultProps = {
    share: false,
    children: []
}

export default Sidebar
